module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-settings"
    }
  }, [_c('h1', [_vm._v("User Settings")]), _vm._v(" "), _c('section', {
    staticClass: "user-data-display"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (_vm.edit.name) ? _c('div', {
    staticClass: "col-xs-10 col-sm-9 name-input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "palceholder": "Last Name"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-xs-10 col-sm-9"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        return _vm.toggleEdit('name')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), (_vm.edit.email) ? _c('div', {
    staticClass: "col-xs-10 col-sm-9 name-input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-xs-10 col-sm-9"
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        return _vm.toggleEdit('email')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), (_vm.edit.password) ? _c('div', {
    staticClass: "col-xs-10 col-sm-9 name-input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-xs-10 col-sm-9"
  }, [_vm._v("••••••••••••")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-1"
  }, [_c('button', {
    staticClass: "btn btn-default btn-xs",
    on: {
      "click": function($event) {
        return _vm.toggleEdit('password')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "change-password col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveUserData()
      }
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-warning",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Done")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-2 fullname"
  }, [_c('b', [_vm._v("Name:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-2 fullname"
  }, [_c('b', [_vm._v("Email:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-2 fullname"
  }, [_c('b', [_vm._v("Password:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f203207"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserSettings.vue
// module id = 282
// module chunks = 1